import React from 'react';
interface ColorSelectorProps {
  selectedColor: string;
  onColorChange: (color: string) => void;
}
export function ColorSelector({
  selectedColor,
  onColorChange
}: ColorSelectorProps) {
  const colors = [{
    name: 'Orange',
    value: '#E8927C'
  }, {
    name: 'Jaune',
    value: '#F4D03F'
  }, {
    name: 'Blanc',
    value: '#F5F5F5'
  }, {
    name: 'Rouge',
    value: '#E74C3C'
  }, {
    name: 'Bleu',
    value: '#5DADE2'
  }, {
    name: 'Vert',
    value: '#58D68D'
  }];
  return <div className="rounded-xl border-2 bg-white p-6 shadow-sm transition-shadow hover:shadow-md" style={{
    borderColor: '#E5E7EB'
  }} data-id="element-20">
      <label className="mb-3 block text-sm font-bold uppercase tracking-wide" style={{
      color: '#6B4423'
    }} data-id="element-21">
        Couleur du médaillon
      </label>
      <select value={selectedColor} onChange={e => onColorChange(e.target.value)} className="w-full rounded-lg border-2 p-3 text-sm font-medium transition-all focus:outline-none focus:ring-2" style={{
      borderColor: '#D1D5DB',
      color: '#000000'
    }} onFocus={e => {
      e.target.style.borderColor = '#6B4423';
      e.target.style.boxShadow = '0 0 0 3px rgba(107, 68, 35, 0.1)';
    }} onBlur={e => {
      e.target.style.borderColor = '#D1D5DB';
      e.target.style.boxShadow = 'none';
    }} data-id="element-22">
        {colors.map(color => <option key={color.value} value={color.value} data-id="element-23">
            {color.name}
          </option>)}
      </select>
    </div>;
}